
    <!-- partial:../../partials/_navbar.html -->
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->
    <!-- partial -->
    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <!-- partial:../../partials/_sidebar.html -->
        
        <!-- partial -->
        <div class="main-panel">
            <div class="content-wrapper" style="padding: .5rem .8rem .5rem 3rem;">
                <div class="page-header">
                    <h3 class="page-title text-primary">
                        
                        Client
                    </h3>
                   
                </div>

                <div class="row" >


                    <div class="col-md-4 stretch-card grid-margin">
                        <div class="card">
                            <div class="card-body" style="border: 1px solid #9c9fa6;">
                                <div class="clearfix">
                                    <div class="text-center" style="padding-top:10px;">
                                        <div class="upload-btn-wrapper">
                                            <button class="btnUpload">Upload &nbsp; <img src="../../assets/UploadIcon.png"> </button>
                                            <input type="file" #file name="myfile" (change)="uploadFile(file.files)" id="myfile" multiple />
                                          </div>

                                        <!-- <input type="file" #file class="btn btn-gradient-danger btn-icon-text" id="myfile" title="njf" style="padding: 14px 0px;" (change)="uploadFile(file.files)"/> -->

                                       <br />
                                        <span style="font-size:14px;">.prn & .pdf Files Only</span>
                                        <!-- <input type="file" id="fileupload" style="visibility:hidden;" /> -->
                                    </div>
                                    <div class="text-center">
                                       
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-md-8 stretch-card grid-margin">
                        <span [hidden]="isShownError" style="font-size:14px;color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="font-size:14px;color: green;">{{SuccessMsg}}</span>
                        
                    </div>


                   
                </div>
               
            </div>

            <div class="content-wrapper">

                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">


                            <div class="card-body" style="padding: 0rem 0rem;">
                                <div class="row">
                                   
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="col-lg-12 form-inline" style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1" >
                                                    <div class="col-lg-5"></div>

                                                    <div class="col-lg-7 " style="padding-right:0px;">
                                                        <div class="form-group" style="float: right;">
                                                            <div class="input-group">
                                                                <input type="text" class="form-control"
                                                                    placeholder="Search..." aria-label="Search..."
                                                                    aria-describedby="basic-addon2" [(ngModel)]="searchText" (keyup)="applyFilter($event.target.value)">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-gradient-danger"
                                                                        type="button">Search</button>
                                                                </div>
                                                            </div>
                                                            <button type="button" class="btn btn-sm " (click)="SavePDF()"> 
                                                                <img src="../../assets/ExportPDF.png"  />
                                                                
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"  />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="mat-elevation-z8" #TABLE1 id="TABLE1" >
                                                    <table mat-table [dataSource]="dataSource" #table style="width: 100%;" matSortmat-table [dataSource]="dataSource" #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                          <th mat-header-cell *matHeaderCellDef >
                                                            S.No </th>
                                                          <td mat-cell *matCellDef="let item; let j = index">
                                                            {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }} </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="boeName" >
                                                          <th mat-header-cell *matHeaderCellDef  mat-sort-header > File Name </th>
                                                          <td mat-cell *matCellDef="let element"  style="cursor: pointer;"> {{element.boeName}} </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="uploadedDate" >
                                                          <th mat-header-cell *matHeaderCellDef  mat-sort-header > Uploaded Date </th>
                                                          <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.uploadedDate}} </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="noOfLineItems" >
                                                          <th mat-header-cell *matHeaderCellDef  mat-sort-header > Line Item Count </th>
                                                          <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.noOfLineItems}} </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="status" >
                                                            <th mat-header-cell *matHeaderCellDef  mat-sort-header > Status </th>
                                                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.status}} </td>
                                                          </ng-container>
                                                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                                      </table>
                                                      <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]" showFirstLastButtons></mat-paginator>



                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                   
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>
        
                    </span>
        
                </div>
            </footer>
            
        </div>
        
    </div>
    
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
        <img src="../../assets/Preloader.gif">
        <!-- <p style="color: white">Please Wait. </p>   -->
        </ngx-spinner>    
